import { createAction } from '@reduxjs/toolkit';
import type {
    IDuplicatesLoadMoreSuccess,
    ILoadDuplicatesCountSuccess,
    ILoadDuplicatesListSuccess,
    ILoadDuplicatesPreviewSuccess,
    IRemoveDuplicateFromViewer,
    IRemoveDuplicatesAllWithLimit,
    IRemoveDuplicatesGroup,
} from 'reactApp/modules/duplicates/duplicates.types';

export const loadDuplicatesListRequest = createAction('duplicates/loadDuplicatesListRequest');
export const loadDuplicatesListSuccess = createAction<ILoadDuplicatesListSuccess>('duplicates/loadDuplicatesListSuccess');
export const loadDuplicatesListFail = createAction('duplicates/loadDuplicatesListFail');
export const resetDuplicatesList = createAction('duplicates/resetDuplicatesList');

export const loadDuplicatesCountRequest = createAction('duplicates/loadDuplicatesCountRequest');
export const loadDuplicatesCountSuccess = createAction<ILoadDuplicatesCountSuccess>('duplicates/loadDuplicatesCountSuccess');
export const loadDuplicatesCountFail = createAction('duplicates/loadDuplicatesCountFail');

export const loadDuplicatesPreviewRequest = createAction('duplicates/loadDuplicatesPreviewRequest');
export const loadDuplicatesPreviewSuccess = createAction<ILoadDuplicatesPreviewSuccess>('duplicates/loadDuplicatesPreviewSuccess');
export const loadDuplicatesPreviewFail = createAction('duplicates/loadDuplicatesPreviewFail');

export const showBestPhotoTooltipStart = createAction('duplicates/showBestPhotoTooltipStart');
export const showBestPhotoTooltip = createAction('duplicates/showBestPhotoTooltip');

export const removeDuplicatesGroupStart = createAction<IRemoveDuplicatesGroup>('duplicates/removeDuplicatesGroupStart');
export const removeDuplicatesAllStart = createAction('duplicates/removeDuplicatesAllStart');
export const removeDuplicatesAllWithLimitStart = createAction<IRemoveDuplicatesAllWithLimit>(
    'duplicates/removeDuplicatesAllWithLimitStart'
);
export const removeDuplicateFromViewerStart = createAction<IRemoveDuplicateFromViewer>('duplicates/removeDuplicateFromViewerStart');
export const removeDuplicateFromContextMenuStart = createAction<IRemoveDuplicateFromViewer>(
    'duplicates/removeDuplicateFromContextMenuStart'
);

export const setDuplicatesDeletionComplete = createAction('duplicates/setDuplicatesDeletionComplete');

export const duplicatesLoadMoreRequest = createAction('duplicates/loadMoreRequest');
export const duplicatesLoadMoreSuccess = createAction<IDuplicatesLoadMoreSuccess>('duplicates/loadMoreSuccess');

export const duplicatesActivate = createAction('duplicates/duplicatesActivate');
